// extracted by mini-css-extract-plugin
export default {"repairOrdersTable":"RepairOrdersTable_repairOrdersTable__J8reB","empty":"RepairOrdersTable_empty__P1248"};